// action types
import { createRequestTypes } from "../../utils";

export const FETCH_CULTIVATION_TIPS = createRequestTypes("FETCH_CULTIVATION_TIPS");

export const fetchCultivationTipsRequest = () =>
    ({ type: FETCH_CULTIVATION_TIPS.REQUEST });

export const fetchCultivationTipsSuccess = (tips) =>
    ({ type: FETCH_CULTIVATION_TIPS.SUCCESS, payload: { tips } });

export const fetchCultivationTipsFailure = (error) =>
    ({ type: FETCH_CULTIVATION_TIPS.FAILURE, payload: { error } });
